import { ExtendedChartWidgetProps, BaseChartSummary } from './types';

/**
 * Returns the CSDK chart configuration ({@link BaseChartSummary}) for LLM consumption.
 * Returns `undefined` when `chartState` has not yet been computed (e.g. unsupported chart type).
 */
export const getBaseChartSummary = (
	widgetProps: ExtendedChartWidgetProps,
): BaseChartSummary | undefined => {
	if (!widgetProps.chartState) return undefined;
	return widgetProps.chartState;
};
